import { Checkbox, FormControlLabel } from '@mui/material';

import { FilterValuesProps } from 'hooks/useFilter';
import { usePedidoFilterContext } from 'pages/compra/pedido/contexts/PedidoFilterContext';

export function PedidoPrioritarioCheckbox() {
    const { filterPrioritario, setFilterPrioritario } = usePedidoFilterContext();

    return (
        <FormControlLabel
            sx={{ mr: 0 }}
            label="Somente produtos prioritários"
            control={<Checkbox />}
            checked={filterPrioritario.value}
            onChange={(e, checked) => setFilterPrioritario((oldState: FilterValuesProps) => ({ ...oldState, value: checked || null }))}
        />
    );
}
